"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toSnakeCase = exports.toCamelcase = void 0;
const camelcaseKeys = require("camelcase-keys");
const convert_keys_1 = require("convert-keys");
const toCamelcase = (object) => {
    try {
        return JSON.parse(JSON.stringify(camelcaseKeys(object, {
            deep: true,
        })));
    }
    catch (error) {
        console.error(error);
    }
    return null;
};
exports.toCamelcase = toCamelcase;
const toSnakeCase = (object) => {
    try {
        return JSON.parse(JSON.stringify((0, convert_keys_1.toSnake)(object)));
    }
    catch (error) {
        console.error(error);
    }
    return null;
};
exports.toSnakeCase = toSnakeCase;
